var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { html } from "lit";
import { property, state } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import { OmniElement } from "../../omni-element.js";
import "../omni-dropdown/omni-dropdown.js";
import "../omni-icon/omni-icon.js";
import { css } from "lit";
const styles = css`:host input::-webkit-outer-spin-button,:host input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}:host input[type=number]{-moz-appearance:textfield}.pagination-container{display:flex;align-items:center;justify-content:center}.pagination-container .items-per-page-container{display:flex;align-items:center;width:fit-content;margin-right:2.25rem}.pagination-container .items-per-page-container .dropdown{align-self:center;width:fit-content;margin-left:1.125rem}.pagination-container .items-per-page-container .dropdown omni-dropdown{width:100%;border-radius:.375rem;border:.0625rem solid var(--color-pale-grey-three);background-color:#fff}.pagination-container .items-per-page-container .dropdown omni-dropdown::part(target){display:flex;height:1.9375rem;padding:.375rem .875rem;justify-content:center;align-items:center}.pagination-container .items-per-page-container .dropdown omni-dropdown::part(icon){height:1.375rem;width:1.375rem}.pagination-container .items-per-page-container .dropdown omni-dropdown::part(label){font-size:.9rem;font-style:normal;font-weight:400;line-height:normal;color:var(--color-almost-black)}.pagination-container .items-per-page-container .dropdown omni-dropdown::part(dropdown){margin-top:.3125rem;margin-bottom:.3125rem;width:100%;height:fit-content}.range-text{color:var(--color-almost-black);font-size:.875rem;font-style:normal;font-weight:400;line-height:normal}.jump-class{display:flex;align-items:center;width:fit-content;font-size:.9rem;font-style:normal;font-weight:400;gap:.4375rem;margin-right:.375rem;margin-left:.375rem}.jump-class input{height:2rem;background:rgba(0,0,0,0);font-size:1rem;text-align:center}.direction-arrows{width:1.5rem;height:1.5rem}.pagination-container>:last-child{margin-right:0}`;
class OmniPagination extends OmniElement {
  constructor() {
    super(...arguments);
    this.page = 1;
    this.itemsPerPage = 10;
    this.itemsPerPageOptions = [10, 20, 30, 40, 50];
    this.forwardDisabled = false;
    this._inputWidth = "2rem";
  }
  static get styles() {
    return [...super.styles, styles];
  }
  async connectedCallback() {
    super.connectedCallback();
    if (this.totalItems) {
      this._totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    }
  }
  async firstUpdated(changedProps) {
    await this.updateComplete;
    if (changedProps.has("page")) {
      this.#resizeInput(this.page);
    }
  }
  #emitPageUpdate(eventDescription) {
    this.dispatchNewEvent("page-change", {
      detail: {
        name: eventDescription,
        page: this.page,
        itemsPerPage: this.itemsPerPage
      }
    });
  }
  #handleItemsPerPage(selection) {
    if (!selection) {
      return;
    }
    if (selection !== this.itemsPerPage) {
      this.itemsPerPage = selection;
      this.page = 1;
    }
    if (this.totalItems) {
      const newTotalPages = Math.ceil(this.totalItems / selection);
      this._totalPages = newTotalPages;
    }
    this.#emitPageUpdate("items-per-page-change");
  }
  #handlePageJump(input) {
    if (input > this._totalPages) {
      this.page = this._totalPages;
    } else if (input < 1) {
      this.page = 1;
    } else {
      this.page = input;
    }
  }
  #handlePageSkip(direction) {
    if (direction === "start") {
      this.page = 1;
    } else {
      this.page = this._totalPages;
    }
    this.#resizeInput(this.page);
  }
  #handleNextPage() {
    if (!this._totalPages || this.page < this._totalPages) {
      this.page += 1;
    }
    this.#resizeInput(this.page);
  }
  #handlePriorPage() {
    if (!this._totalPages || this.page > 1) {
      this.page -= 1;
    }
    this.#resizeInput(this.page);
  }
  #functionFactory(action, page, event) {
    if (page === this.page) {
      return;
    }
    const actions = {
      forward: () => this.#handleNextPage(),
      back: () => this.#handlePriorPage(),
      jump: (page2, event2) => {
        this.#handlePageJump(page2);
        event2.target.value = String(this.page);
        this.#resizeInput(this.page);
        event2.target.blur();
      },
      start: () => this.#handlePageSkip("start"),
      end: () => this.#handlePageSkip("end")
    };
    if (action && actions[action]) {
      action === "jump" ? actions[action](page, event) : actions[action]();
      this.#emitPageUpdate(action);
    } else {
      console.error("Invalid action");
    }
  }
  #resizeInput(input) {
    if (String(input).length < 2) {
      this._inputWidth = "2rem";
    } else {
      const inputWidth = String(input).length;
      this._inputWidth = `${inputWidth}rem`;
    }
  }
  get #showingItemsTemplate() {
    let endingRange = this.page * this.itemsPerPage;
    endingRange = endingRange > this.totalItems ? this.totalItems : endingRange;
    const startingRange = endingRange - this.itemsPerPage + 1;
    return html`<div class="items-per-page-container">
      ${!this.totalItems ? html` <p class="range-text">Showing ${this.itemsPerPage} items</p> ` : html` <p class="range-text">Showing ${startingRange} - ${endingRange} of ${this.totalItems}</p> `}
      <div class="dropdown">
        <omni-dropdown
          .options=${this.itemsPerPageOptions}
          .value=${[this.itemsPerPage]}
          .placeholder=${String(this.itemsPerPage)}
          .hidefooter=${true}
          variant="label"
          @change=${(e) => {
      this.#handleItemsPerPage(e.detail);
    }}></omni-dropdown>
      </div>
    </div>`;
  }
  get #currentPageTemplate() {
    return html` <div class="jump-class">
      <input
        type="number"
        style=${styleMap({ width: this._inputWidth, background: "transparent" })}
        .value=${this.page}
        @input=${(e) => this.#resizeInput(e.target.value)}
        @keydown=${(e) => e.key === "Enter" && this.#functionFactory("jump", Number(e.target.value), e)}
        @blur=${(e) => this.#functionFactory("jump", Number(e.target.value), e)} />
      ${!this.totalItems ? "" : html`<span>of</span> <span>${this._totalPages}</span>`}
    </div>`;
  }
  get #navigationalArrowsForwardTemplate() {
    return html` <div class="navigational-buttons" style="display: flex; align-items: center; justify-content: center">
      <button
        class="button is-text"
        ?disabled=${this.page === this._totalPages || this.forwardDisabled}
        @click=${() => this.#functionFactory("forward")}>
        <omni-icon class="direction-arrows" aria-label="right" icon-id="omni:interactive:right"></omni-icon>
      </button>
      ${!this.totalItems ? "" : html`<button
            class="button is-text"
            ?disabled=${this.page === this._totalPages}
            @click=${() => this.#functionFactory("end")}>
            <omni-icon aria-label="right" icon-id="omni:interactive:lastPage"></omni-icon>
          </button>`}
    </div>`;
  }
  get #navigationalArrowsBackTemplate() {
    return html`
      <div class="navigational-buttons" style="display: flex; align-items: center; justify-content: center">
        <button ?disabled=${this.page === 1} class="button is-text" @click=${() => this.#functionFactory("start")}>
          <omni-icon aria-label="firstPage" icon-id="omni:interactive:firstPage"></omni-icon>
        </button>
        <button ?disabled=${this.page === 1} class="button is-text" @click=${() => this.#functionFactory("back")}>
          <omni-icon class="direction-arrows" aria-label="left" icon-id="omni:interactive:left"></omni-icon>
        </button>
      </div>
    `;
  }
  // prettier-ignore
  render() {
    return html`
      <omni-style>
        <div class="pagination-container">
          ${this.#showingItemsTemplate} 
          ${this.#navigationalArrowsBackTemplate} 
          ${this.#currentPageTemplate}
          ${this.#navigationalArrowsForwardTemplate}
        </div>
      </omni-style>
    `;
  }
}
__decorateClass([
  property({ type: Number })
], OmniPagination.prototype, "page", 2);
__decorateClass([
  property({ type: Number })
], OmniPagination.prototype, "totalItems", 2);
__decorateClass([
  property({ type: Number })
], OmniPagination.prototype, "itemsPerPage", 2);
__decorateClass([
  property({ type: Array, attribute: false })
], OmniPagination.prototype, "itemsPerPageOptions", 2);
__decorateClass([
  property({ type: Boolean })
], OmniPagination.prototype, "forwardDisabled", 2);
__decorateClass([
  state()
], OmniPagination.prototype, "_inputWidth", 2);
__decorateClass([
  state()
], OmniPagination.prototype, "_totalPages", 2);
OmniElement.register("omni-pagination", OmniPagination);
export {
  OmniPagination
};
//# sourceMappingURL=omni-pagination.js.map
